import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { FILTERABLE_FIELD_TYPES } from '@cli-constants/schema-codegen.js'

export function getFilterableFields(fields: SchemaField[]): SchemaField[] {
  return fields.filter(
    (field) =>
      !field.primaryKey && field.name !== 'sortOrder' && FILTERABLE_FIELD_TYPES.has(field.type)
  )
}
